import { create } from 'zustand';
import { supabase } from '../lib/supabase';

export interface Industry {
  id: number;
  slug: string;
  label: string;
  created_at?: string;
  updated_at?: string;
  validated?: boolean;
  suggested_by?: string;
  industry_description?: string;
  deleted?: boolean;
}

interface IndustryState {
  industries: Industry[];
  loading: boolean;
  error: string | null;
  fetchIndustries: () => Promise<void>;
}

export const useIndustryStore = create<IndustryState>(set => ({
  industries: [],
  loading: false,
  error: null,
  fetchIndustries: async () => {
    try {
      set({ loading: true, error: null });

      const { data, error: fetchError } = await supabase
        .from('industries')
        .select('id, slug, label')
        .order('label');

      if (fetchError) {
        throw fetchError;
      }

      set({ industries: data || [], loading: false });
    } catch (err) {
      set({
        error: err instanceof Error ? err.message : 'An error occurred while fetching industries',
        loading: false,
      });
    }
  },
}));
